// Formato compacto para números que se muestran en grande.
//
// En los tableros hay celdas de ancho fijo con tipografía de 32-46 px: un valor de
// cuatro o cinco dígitos desborda la columna y rompe la grilla. Pasa de verdad con los
// días sin actualizar firmas de antivirus, que en equipos abandonados llegan a cuatro
// cifras (hoy el peor de CDM va por 456 y sigue subiendo).
//
// Separador decimal coma, que es lo que corresponde en es-AR.
export function compacto(n) {
  // null/undefined NO son cero: Number(null) da 0 y mostraría un dato inventado.
  if (n === null || n === undefined || n === '') return '—';
  const v = Number(n);
  if (!Number.isFinite(v)) return n;

  const escala = (valor, sufijo) => {
    // Se redondea ANTES de elegir el formato: con 9999, valor vale 9,999 y la rama
    // decimal imprimía "10,0K" en vez de "10K". Mismo problema en el borde de 1M.
    const und = Math.abs(valor) >= 9.95;
    return (und ? Math.round(valor) : valor.toFixed(1).replace('.', ',')) + sufijo;
  };

  const abs = Math.abs(v);
  if (abs < 1000) return String(v);
  if (abs < 999500) return escala(v / 1000, 'K');
  return escala(v / 1000000, 'M');
}

// Igual que compacto() pero devolviendo también el valor exacto, para ponerlo en el
// title del elemento: la celda muestra "1,2K" y el tooltip dice "1234".
export function compactoConTitulo(n) {
  const v = Number(n);
  return {
    texto: compacto(n),
    titulo: n !== null && n !== undefined && Number.isFinite(v) && Math.abs(v) >= 1000
      ? String(v)
      : undefined,
  };
}
